export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-behance-03749f149dff51e5c69c3a28a21a5417.svg";